import React, { useEffect, useState } from 'react';
import {Link, useParams} from 'react-router-dom';

import {useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import StationAPI from "../../../apis/adminApi/stationAPI";
import FormContentLoader from "../../loaders/FormContentLoader";
import Field from "../../forms/Field";
import MyButton from "../../assets/MyButton";
import Select from "../../forms/Select";

const EditStation = () => {
    const { formState } = useForm();
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [loading, setLoading] = useState(true);
    const [agencies, setAgencies] = useState([]);
    let {stationId} = useParams();

    const [showLoader, setShowLoader] = useState(false);

    const [station, setStation] = useState({
        station_name : "", station_city : "", station_address : "", id : stationId
    });

    const [editing, setEditing] = useState(false);

    const [errors, setErrors] = useState({
        station_name : "", station_city : "", station_address : "",
    });


    //Recuperation
    const fetchStation = async id => {
        try{
            const { station_name, station_city, station_address } = await StationAPI.find(stationId);
            setStation({ station_name, station_city, station_address });
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger le point de vente démandé !");
            navigate("/admin/stations");
        }
    };


    useEffect(() => {
        setEditing(true);
        fetchStation(stationId);
    }, [stationId]);


    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setStation({...station, [name] : value})
    };



    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await StationAPI.updateStation(stationId, station);
            toast.success("Station modifié avec succès");
            setTimeout(() => setShowLoader(false), 1000);
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification de la station !");
            }
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    {loading && <FormContentLoader />}
                    {!loading && <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Modifier une station</h5>

                                        <Field
                                            name="station_name"
                                            error={errors.station_name}
                                            value={station.station_name}
                                            onChange={handleChange}
                                            label="Nom"
                                        />

                                        <Field
                                            name="station_city"
                                            error={errors.station_city}
                                            value={station.station_city}
                                            onChange={handleChange}
                                            label="Ville"
                                        />

                                        <Field
                                            name="station_address"
                                            error={errors.station_address}
                                            value={station.station_address}
                                            onChange={handleChange}
                                            label="Adresse"
                                        />


                                        <MyButton
                                            text="Modifier"
                                            onSubmit={handleSubmit}
                                            loading={showLoader}
                                            disabled={showLoader}
                                        />
                                        <Link to="/admin/stations" className="btn btn-danger mx-2">Annuler</Link>
                                    </div>
                                </div>
                            </form>
                    }
                </div>
            </div>
        </div>
    );
};

export default EditStation;
